import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Handler from './_Handler';
import Item from './_Item';
import {setData} from '../../features/movimentiSlice';
import Skeleton from '@mui/material/Skeleton';
import { DateTime, Interval } from 'luxon';
import md5 from 'md5';

function ListaMovimenti() {
    const dispatch = useDispatch();
    const customerId = useSelector((user) => user.user.info.customer_id);
    const customerCode = useSelector((user) => user.user.info.customer_code);
    const data = useSelector((user) => user.movimenti.data)
    const [seeTag, setSeeTag] = useState(false);
    const [tagList, setTagList] = useState(null)
    const [currentTag, setCurrentTag] = useState('tutti')
    const [intervalFilter, setIntervalFilter] = useState({
        label: 'Tutti',
        interval: Interval.fromDateTimes(DateTime.local(2000), DateTime.local()),
    });
    const [counterPosts, setCounterPosts] = useState(3);
    const tkn = md5(customerId + 'oYmAIdtki%lu') 

    useEffect(() => {
        if(data) {
            return
        } else {
            init()
        }
    }, [customerId]);

    const toDateTime = (dataItem) => {
        const [year, month] = dataItem.date.split('-');
        return DateTime.local(+year, +month);
    }

    const changeTagLabel = (r) => {
        switch(r) {
            case 'consumi':
              return 'Consumi';
            case 'incasso-sdd':
                return 'Incassi'
            case 'ricarica': 
                return 'Ricarica'
            case 'ricariche-bonus': 
                return 'Ricarica Bonus'
            case 'canone-rai': 
                return 'Canone Rai'
            case 'upsell':
                return 'Upsell';
            case 'estratto-conto': 
                return 'Estratto conto';
            case 'bonus-sociale':
                return 'Bonus Sociale';
            case 'regala-energia':
                return 'Regala energia';
            case 'rettifica':
                return 'Rettifica';
            case 'oneri-diversi':
                return 'Oneri diversi';
            case 'commissioni' :
                return 'Commissioni';
            default:
              return r;
        }
    }
  
    const init = async () => {
        const movementsApi = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getMovimentazioni.php?customer_id=${customerId}&customer_code=${customerCode}&tkn_pvt=${tkn}`
        await axios.get(movementsApi).then(({data}) => {
            const result = data.result.reverse();
            setTagList(result.map((r) => r.tag).filter((e, i, a) => a.indexOf(e) === i))
            let resultData = Object.values(
                result.reduce((acc, item) => {
                  const dateCorrect = DateTime.fromISO(item.data_emissione).toFormat("y-MM");
                  if (!acc[dateCorrect])
                    acc[dateCorrect] = {
                      date: dateCorrect,
                      data: [],
                      saldo: result.map((r) => r.saldo)
                    };
                  acc[dateCorrect].data.push(item);
                  return acc;
                }, {})
            );
            dispatch(setData(resultData));
        })
    }
    const checkIsActive = (r) => {
        if(typeof currentTag === `string` ){
            return r === currentTag
        } else {
            return currentTag.has(r)
        }
    } 
    const toggleTag = (r) => {
        if(typeof currentTag !== `string` && currentTag.has(r)){
            currentTag.delete(r)
            if(currentTag.size === 0){
                setCurrentTag('tutti')
            } else {
                setCurrentTag(new Set ([...currentTag.values()]))
            }
        } else {
            setCurrentTag(prevState => prevState === 'tutti' ? (
                new Set ([r])
            ) : new Set ([...prevState.values(), r]) )
        }
    }

    let handlerInterval, filteredData = [];
    if (data && data.length > 0) {
        const dates = [toDateTime(data[0]), toDateTime(data[data.length - 1])];
        const min = DateTime.min(...dates).startOf('month');
        const max = DateTime.max(...dates).endOf('month');
        handlerInterval = Interval.fromDateTimes(min, max);
        filteredData = data
            .map(r => ({
                date: r.date,
                data: r.data.filter((dato) => intervalFilter.interval.contains(DateTime.fromISO(dato.data_emissione)))
            }))
            .filter(r => r.data.length > 0);
    }

    return (
        <div className="listaMovimenti">
            <Handler
                monthsInterval={handlerInterval}
                {... { seeTag, setSeeTag, intervalFilter, setIntervalFilter }}
            />
            <ul className="tags" style={seeTag ? {display: 'grid'} : {display: 'none'}}>
                <li onClick={() => setCurrentTag('tutti')} className={currentTag === 'tutti' ? 'tag active' : 'tag' }>
                    <p>Tutti</p>
                </li>
                {tagList!== null ? (
                  tagList.map((r, i) => <li key={i} onClick={() => toggleTag(r)} className={checkIsActive(r)  ? 'tag active' : 'tag'}><p>{changeTagLabel(r)}</p></li>)
                ) : null} 
            </ul>
            <div className="items" style={seeTag ? null : {marginTop: '1rem'}}>
                {data === null ? (
                    <>
                        <div className="skeleton">
                            <div className="top">
                                <Skeleton variant="text" width={150}/>
                                <Skeleton variant="text" width={100}/>
                            </div>
                            <Skeleton variant="rectangular" height={60} />
                        </div>
                        <div className="skeleton">
                            <div className="top">
                                <Skeleton variant="text" width={150}/>
                                <Skeleton variant="text" width={100}/>
                            </div>
                            <Skeleton variant="rectangular" height={60} />
                        </div>
                        <div className="skeleton">
                            <div className="top">
                                <Skeleton variant="text" width={150}/>
                                <Skeleton variant="text" width={100}/>
                            </div>
                            <Skeleton variant="rectangular" height={60} />
                        </div>
                    </>
                ) : currentTag === 'tutti' ? filteredData.slice(0, counterPosts).map((r, i) => (
                    <>
                        <div key={i} className="item main_date">
                            <div className="top">
                                <div className="date">
                                    <p>{DateTime.fromISO(r.date, {locale: 'it'}).toFormat('LLLL y')}</p>
                                </div>
                                <div className="amount">
                                    <p>{r.data[0].saldo.toFixed(2).replace(/\./g, ",")} €</p>
                                </div>
                            </div>
                        </div>
                        {r.data.map((r, i) => (
                                <Item 
                                    filtered={false}
                                    key={i} 
                                    id={r.entry_id} 
                                    emissione={r.data_emissione} 
                                    scadenza={r.data_scadenza} 
                                    amount={r.amount} 
                                    reason={r.reason} 
                                    note={r.note} 
                                    kwh={r.entry_kwh} 
                                    price={r.entry_price} 
                                    tag={r.tag} 
                                    url={r.url_fattura}
                                />
                            
                        ))}
                    </>
                    ) ) : filteredData.map((r) => (
                        {
                            date: r.date,
                            data: r.data.filter((dato) => currentTag.has(dato.tag))
                        }
                    )).filter((r) => r.data.length > 0).map((r) => (
                        <>
                            <div className="item main_date">
                                <div className="top">
                                    <div className="date">
                                        <p>{DateTime.fromISO(r.date, {locale: 'it'}).toFormat('LLLL y')}</p>
                                    </div>
                                    <div className="amount">
                                        <p>{r.data[0].saldo.toFixed(2)} €</p>
                                    </div>
                                </div>
                            </div>
                            {r.data.map((r, i) => (
                                <Item 
                                    filtered={false}
                                    key={i} 
                                    id={r.entry_id} 
                                    emissione={r.data_emissione} 
                                    scadenza={r.data_scadenza} 
                                    amount={r.amount} 
                                    reason={r.reason} 
                                    note={r.note} 
                                    kwh={r.entry_kwh} 
                                    price={r.entry_price} 
                                    tag={r.tag} 
                                    url={r.url_fattura}
                                />
                            ))}
                        </>
                    ))
                } 
         
                {data === null ? null : counterPosts >= data.length ? (
                    <div className="lastItem">
                        <p className="no-more">Non ci sono altri movimenti da visualizzare</p>
                    </div>
                ) : (
                    <div className="lastItem" onClick={() => setCounterPosts(counterPosts + 3)}>
                        <p className="load-more">Clicca per caricare altri movimenti</p>
                    </div>
                )}
                
                  
            </div>
        </div>
    );
}

export default ListaMovimenti
